// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__3BZ-x","slick-next":"CustomSlider_slick-next__xdufX"};